import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { CurrentUser } from './domain/current-user';
import {
	openCacheInspector,
	openTaskModal,
	setProject,
	setUser,
} from './store';

@Injectable()
export class NgCore {
	public constructor(private readonly store: Store) {}

	public openTaskModal(): void {
		this.store.dispatch(openTaskModal());
	}

	/** Outil de dev : inspection du cache HTTP. */
	public openCacheInspector(): void {
		this.store.dispatch(openCacheInspector());
	}

	public setProject(id: number, label: string): void {
		this.store.dispatch(
			setProject({
				projectId: id,
				projectLabel: label,
			})
		);
	}

	public setUser(user: CurrentUser, isAdmin: boolean): void {
		const currentUser: CurrentUser = {
			id: user.id,
			uuid: user.uuid,
			firstname: user.firstname,
			lastname: user.lastname,
			isAdmin,
		};
		this.store.dispatch(
			setUser({
				user: currentUser,
			})
		);
	}
}
